import clsx from 'clsx';

import SvgIconChevron from '@/common/icons/generated/common/IconChevron';
import { IconProps } from '@/common/icons/icon.interface';

import styles from './ChevronIcon.module.scss';

type ChevronIconProps = IconProps & {
  direction: 'up' | 'down' | 'left' | 'right';
};

const ChevronIcon = ({ size, className, color, direction, ...rest }: ChevronIconProps) => {
  return (
    <SvgIconChevron
      className={clsx(styles[direction], className)}
      color={color}
      height={size}
      width={size}
      {...rest}
    />
  );
};

export default ChevronIcon;
